<div
  *ngIf="formFieldConfig || (value && label)"
  [ngClass]="displayHorizontal ? 'row' : ''"
  [attr.data-testId]="getTestId()"
>
  <div class="strong" [class.d-flex]="infoText" [class.align-items-center]="infoText" [class.gap-1]="infoText"
       [ngClass]="displayHorizontal ? 'col-6' : ''">
    {{ label || formFieldConfig!.label | localize }}
  </div>
  <div class="multiline" [ngClass]="displayHorizontal ? 'col-4' : ''">
    <span>{{ getLocalizedFormValue() | localize }}</span>
    <span *ngIf="formFieldConfig?.infoLabel"
          class="whitespace-prefix">{{ formFieldConfig!.infoLabel | localize }}</span>
    <app-field-info *ngIf="infoText" class="ms-2" [testId]="getTestId() + '-info'" [infoText]="infoText"></app-field-info>
  </div>
</div>
